import type { LucideIcon } from 'lucide-react';

export type HopType = {
  address: string;
  name: string | null;
  latency: string[];
  hop: number;
  lat?: number;
  lon?: number;
  city?: string;
  isp?: string;
  subdivIso?: string;
};

export interface TracertRef {
  startTrace: (
    ipToTest: string,
    customMaxHops?: string | number,
    customTimeout?: string | number
  ) => void;
  resetTrace: () => void;
}

export interface TracertProps {
  onStateChange?: (state: { isRunning: boolean; isDone: boolean }) => void;
  equipmentId: string;
}

export interface TracertStats {
  state: string;
  host: string;
  responseTime: string;
  hopsCount: string;
  maxHopCount: string;
  numberTries: string;
  timeout: string;
  dataBlockSize: string;
  dscp: string;
  interfaceTest: string;
}

export const INITIAL_STATS: TracertStats = {
  state: 'None',
  host: '',
  responseTime: 'N/A',
  hopsCount: 'N/A',
  maxHopCount: 'N/A',
  numberTries: 'N/A',
  timeout: 'N/A',
  dataBlockSize: 'N/A',
  dscp: 'N/A',
  interfaceTest: 'N/A',
};

export interface TimeMetricItem {
  id: string;
  icon: LucideIcon;
  label: string;
  value: string;
  unit: string;
  color?: string;
}

export interface ConfigItemData {
  id: string;
  icon: LucideIcon;
  label: string;
  value: string;
}

export interface StatusInfo {
  color?: string;
  Icon: LucideIcon;
  label: string;
}
